export default __webpack_public_path__ + "static/media/assets-article-oliv_01.031a3a82.jpg";